
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KudoMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Kudo"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageId"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kudosSumWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasGivenKudo"},"arguments":[],"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/messages/MessageId.fragment.graphql").definitions));


    module.exports = doc
  
